<template>
  <selector
    v-if="phoneCodeList.length"
    :options="phoneCodeList"
    :value="selectedValue"
    :disable="disable"
    :iconType="iconType"
    @input="
      (inp) => {
        this.$emit('input', inp.replace('+', ''));
      }
    "
  >
  </selector>
</template>

<script>
import Selector from "./selector.vue";
import PhoneCodes from "country-calling-code";

export default {
  props: {
    name: { type: String, default: "" },
    value: { type: String | Number, defualt: "" },
    disable: { type: Boolean, defualt: false },
    iconType: { type: String, default: "" },
    country: { type: String, default: "" },
  },
  watch: {
    country() {
      let phoneCode = PhoneCodes.filter(({ isoCode2 }) => {
        return isoCode2.toLowerCase() == this.country.toLowerCase();
      });

      if(phoneCode.length) {
        this.$emit('input', phoneCode[0].countryCodes[0]);
      }
    },
  },
  data() {
    return {
      phoneCodeList: [],
    };
  },
  mounted() {
    this.loadPhoneData();
  },
  methods: {
    loadPhoneData() {
      let codeList = [];
      PhoneCodes.forEach((code) => {
        codeList = codeList.concat(code.countryCodes);
      });

      this.phoneCodeList = codeList
        .sort((a, b) => parseInt(a) - parseInt(b))
        .map((code) => "+" + code);
    },
  },
  computed: {
    selectedValue() {
      if (this.value) {
        return "+" + this.value;
      } else {
        return "+45";
      }
    },
  },
  components: {
    Selector,
  },
};
</script>